const pagesList = [
   {
    name: "בית",
    path: "/",
  },
  {
    name: "בית המדרש",
    path: "/BeitHamidrash",
  },
  {
    name: "התלמוד הממוזג",
    path: "/TalmudHaMemuzag",
  },
  {
    name: "צרו קשר",
    path: "/Contact",
  },
  {
    name: "מה חדש",
    path: "/WhatsNew",
  },
  {
    name: "אודות",
    path: "/About",
  },
  {
    name: "הוצאה לאור",
    path: "/Publishing",
  },
];


export default pagesList;
